export default __webpack_public_path__ + "static/media/pin-location.fcce81ae.svg";